<cac-button (onClick)="export.emit($event)" [permission]="permission()" class="h-12 w-fit mb-4" appearance="text" icon="excel-file">
  <span class="mr-1"> خروجی اکسل</span>
</cac-button>